<template>
  <div v-if="loading" class="preview-multi-select">
    <b>{{ $i18n('interface.novo_filtro.fornecedor') }}:</b> <span>{{ $i18n('interface.novo_filtro.selecione') }}</span>
  </div>
  <MultiSelect
    v-else
    :label="$i18n('interface.novo_filtro.fornecedor')"
    :campos="fornecedores"
    :filtro="filtro"
    :filtro_id="filtro.filtro"
    :path="path"
    @atualizar="atualizar"
  />
</template>
<script>
import MultiSelect from '../../components/MultiSelect.vue';
export default {
  props: {
    filtro: {
      type: Object,
      required: true,
    },
    path: {
      type: String,
      required: true
    },
  },
  data() {
    return {
      fornecedores: [],
      loading: true
    }
  },
  components: {
    MultiSelect
  },
  methods: {
    atualizar(selecionados) {
      this.$aplicaFiltroEmURL(this.filtro.filtro, selecionados, this.path);
      this.$store.commit('addFiltro', this.filtro);
      this.$store.commit('addFiltroAplicado', {
        filtro: this.filtro.filtro,
        valor: selecionados
      });
    },
  },
  mounted() {

    const { parametros } = this.filtro;
    const paramsDefault = { params: { tipos: ['fornecedor'] } };
    if (parametros && parametros!=null && typeof parametros === 'object') {
      paramsDefault.params = parametros ;
    }
    this.$api.get('/stakeholders/busca_todos', paramsDefault ).then(response => {
      const stakeholders = response.data;
      this.fornecedores = stakeholders.map(stakeholder => ({
        id: stakeholder.id,
        name: stakeholder.label
      }));
    }).catch(error => {
      console.error('Erro ao buscar fornecedores:', error);
    }).finally(() => {
      this.loading = false;
    });
  }
}
</script>
